import {combineReducers} from "@ngrx/store";
import * as error from './error/store/error.reducers';

export interface IGeneralState {
    error: error.State;
}

export const generalStateInitialState: IGeneralState = {
    error: error.initialState,
}

export const reducer = combineReducers(
    {
        error: error.reducer,
    },
    generalStateInitialState,
);
